<template>
  <div>
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <v-container
        v-if="!loading && item.title"
        class="pb-10 pb-md-13 pb-lg-16 pt-0"
      >
        <div
          class="d-flex align-center mx-n3 mx-md-0 position-relative item-img"
          :style="{
            backgroundImage: `linear-gradient(0deg, #666A9E, #666A9E), url(${
              files + item.img + '?resize=1&w=960'
            })`,
          }"
          width="100%"
        >
          <v-col
            class="mx-auto position-relative"
            cols="8"
            sm="6"
            md="5"
            lg="4"
          >
            <img
              class="d-block"
              :src="files + item.img_brand + '?resize=1&w=600'"
              :alt="item.title"
              width="100%"
            />
          </v-col>
        </div>

        <div
          v-if="item.text"
          class="grey--text text--darken-2 mt-10 ck-content"
          v-html="item.text"
        ></div>

        <div v-if="item.video" class="mt-10 video">
          <iframe
            class="d-block"
            :src="`https://www.youtube.com/embed/${getYoutubeCode(item.video)}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>

        <PartnersProductsSection />
      </v-container>
    </transition>
  </div>
</template>

<script>
import { getYoutubeCode } from "../utils/getYoutubeCode";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import PartnersProductsSection from "../components/sections/PartnersProductsSection.vue";

const _config = {
  mod: "partners",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    items: [],
  }),
  created() {
    this.get();
  },
  computed: {
    whatsapp() {
      return this.$rest("informations").item.whatsapp_float;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getYoutubeCode,
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;
        })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  components: {
    LoadingWidget,
    PartnersProductsSection,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  aspect-ratio: 1920 / 680;
  background-blend-mode: color, normal;
  background-position: center;
  background-size: cover;
}
</style>
